/* Hygge Days — auto-omaggio v2 (1–25 agosto 2026).
   Alla soglia di 49,90€ di spesa "vera" aggiunge da solo il regalo del drop attivo;
   sotto soglia lo rimuove. v2: si aggancia al pub/sub del tema (PUB_SUB_EVENTS.cartUpdate)
   così agisce solo a tema fermo (niente conflitti di indici riga → niente cart_error) e
   dopo ogni modifica ripubblica lo stesso evento: drawer e pagina carrello si
   ri-renderizzano da soli, senza reload. Cintato per data: fuori dall'1–25 ago dorme.
   Rimozione: node deploy_autogift.mjs --rollback. */
(function () {
  'use strict';

  var THRESHOLD = 4990; // centesimi
  var SOURCE = 'hygge-autogift';
  var DROPS = [
    { start: '2026-08-01', end: '2026-08-06', variant: 58659406577989 }, // 1 Kit Estate
    { start: '2026-08-06', end: '2026-08-11', variant: 58659406643525 }, // 2 Hygge Routine
    { start: '2026-08-11', end: '2026-08-16', variant: 58659406709061 }, // 3 Frutta e verdura
    { start: '2026-08-16', end: '2026-08-21', variant: 58659406774597 }, // 4 Denti in forma
    { start: '2026-08-21', end: '2026-08-26', variant: 58659406840133 }  // 5 Misterioso
  ];
  var GIFT_IDS = DROPS.map(function (d) { return d.variant; });

  function activeDrop() {
    var now = Date.now();
    for (var i = 0; i < DROPS.length; i++) {
      var s = new Date(DROPS[i].start + 'T00:00:00+02:00').getTime();
      var e = new Date(DROPS[i].end + 'T00:00:00+02:00').getTime();
      if (now >= s && now < e) return DROPS[i];
    }
    return null;
  }

  var busy = false;
  var pending = false; // richiesta di sync arrivata mentre ero occupato

  function sync() {
    var drop = activeDrop();
    if (!drop) return;
    if (busy) { pending = true; return; }
    busy = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var realTotal = 0;
        var giftLines = [];
        (cart.items || []).forEach(function (it) {
          if (GIFT_IDS.indexOf(it.variant_id) !== -1) giftLines.push(it);
          else realTotal += it.final_line_price;
        });
        var activeLines = giftLines.filter(function (g) { return g.variant_id === drop.variant; });
        var wrongLines = giftLines.filter(function (g) { return g.variant_id !== drop.variant; });

        // regali di drop passati → via
        if (wrongLines.length) {
          var upd = {};
          wrongLines.forEach(function (g) { upd[g.key] = 0; });
          return post('/cart/update.js', { updates: upd });
        }
        // sotto soglia con regalo → via
        if (realTotal < THRESHOLD && activeLines.length) {
          var upd2 = {};
          activeLines.forEach(function (g) { upd2[g.key] = 0; });
          return post('/cart/update.js', { updates: upd2 });
        }
        // sopra soglia senza regalo → aggiungi
        if (realTotal >= THRESHOLD && !activeLines.length) {
          return post('/cart/add.js', { id: drop.variant, quantity: 1 });
        }
        // regalo duplicato → riporta a 1
        if (activeLines.length && activeLines[0].quantity > 1) {
          var fix = {}; fix[activeLines[0].key] = 1;
          return post('/cart/update.js', { updates: fix });
        }
        return false; // nessuna modifica
      })
      .then(function (changed) {
        busy = false;
        if (changed) rerender();
        if (pending) { pending = false; setTimeout(sync, 300); }
      })
      .catch(function () { busy = false; pending = false; });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok; });
  }

  // Ri-render nativo: il tema ascolta cartUpdate e ridisegna drawer/carrello da solo
  // (cart.js onCartUpdate). In più aggiorno la bolla del contatore in header.
  function rerender() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE });
    }
    refreshBubble();
    // sulla pagina carrello il footer coi totali non è coperto da onCartUpdate → reload
    if (location.pathname.indexOf('/cart') === 0 && document.querySelector('cart-items')) {
      location.reload();
    }
  }

  function refreshBubble() {
    var el = document.getElementById('cart-icon-bubble');
    if (!el) return;
    fetch('/cart?section_id=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('.shopify-section') || doc.body;
        var dst = el.querySelector('.shopify-section') || el;
        dst.innerHTML = src.innerHTML;
      })
      .catch(function () { /* no-op */ });
  }

  function start() {
    // trigger principale: il pub/sub del tema (globali lessicali, non window.*),
    // che scatta a modifica COMPLETATA
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === SOURCE) return; // il mio stesso evento
        setTimeout(sync, 250);
      });
    }
    // fallback: flussi che non pubblicano (app terze) — hook fetch con attesa lunga
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(sync, 1500); });
      }
      return p;
    };
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (/\/cart\/(add|change|update|clear)/.test(url || '')) {
        this.addEventListener('load', function () { setTimeout(sync, 1500); });
      }
      return origOpen.apply(this, arguments);
    };
    // sync all'apertura pagina
    setTimeout(sync, 900);
  }

  if (activeDrop()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }
})();
